import React, { useState, useEffect, useCallback } from "react";

import { Box } from "@mui/material";

import Placeholder from "../../../Components/UI/Placeholder";
import NestedAccordion from "./NestedAccordion";

const TrainerBatchwiseTable = (props) => {

    //State
    const [tableDetailData, setTableDetailData] = useState([]);

    useEffect(() => {
        initialRender();
    }, [props]);

    const initialRender = useCallback(async () => {
        console.log("props.tableDetailData.length",props.tableDetailData);
        setTableDetailData([]);
        let maindata = {};


        if (props.tableDetailData.length > 0) {
            let uniqueClassWiseData = [
                ...new Set(props.tableDetailData.map((item) => item.context.classId))
            ];
            console.log("uniqueClassWiseData===>", uniqueClassWiseData);

            let classWiseData = [];
            uniqueClassWiseData.forEach((itemData, index) => {
                let logData = props.tableDetailData.filter((obj) => {
                    return obj.context.classId === itemData;
                });

                let uniqueDateWiseData = [
                    ...new Set(logData.map((item) => item.created_at)),
                ];

                uniqueDateWiseData.sort(function compare(a, b) {
                    let dateA = new Date(b);
                    let dateB = new Date(a);
                    return dateA - dateB;
                });
                let mainObj = {};
                mainObj.classId = itemData;
                mainObj.level = 'root';
                mainObj.id = `${index}`;
                let detailData = [];
                uniqueDateWiseData.forEach((dateWiseData, index1) => {
                    let obj = {};

                    let objDatewiseData = logData.filter((objLogData) => {
                        return objLogData.created_at === dateWiseData;
                    });
                    // console.log("objDatewiseData====>", objDatewiseData);
                    let totalTime = objDatewiseData.reduce((acc, val) => {
                        return acc + Number(val.sum);
                    }, 0);
                    obj.dateId = dateWiseData;
                    obj.level = 'parent';
                    obj.id = `${index}_${index1}`;
                    obj.totalTime = totalTime;
                    obj.children = objDatewiseData;
                    obj.detailData = objDatewiseData;
                    detailData.push(obj);
                });
                mainObj.detailData = detailData;
                mainObj.children = detailData;
                classWiseData.push(mainObj);
            });
            maindata.children = classWiseData;
            console.log("maindata", maindata);
            setTableDetailData(maindata);
        }
    }, [props]);

    // Set class list
    const filterClass = (classId) => {
        let findObj = props.allClasses.find((obj) => {
            return obj.id == classId
        });
        return findObj?.value || 'NA';
    };


    return (
        <Box>
            <NestedAccordion
                tableDetailData={tableDetailData}
                filterClass={filterClass}
            />
            {tableDetailData && tableDetailData.length == 0 && (
                <Placeholder
                    primaryText="No trainer data found"
                    secondaryText="No trainer data found!"
                    image="assign"
                ></Placeholder>
            )}
        </Box>
    );
};
export default TrainerBatchwiseTable;
